import * as React from 'react';



export default class AssociatedWorkkards extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
	  <svg className={this.props.className} viewBox="0 0 16 16" xmlnsXlink="http://www.w3.org/1999/xlink">
		<g id="icons/asso_workkards/active" strokeWidth="1" fillRule="evenodd" transform="translate(-1.000000, 0.000000)">
        <g id="Group-65-Copy" transform="translate(2.000000, 1.000000)">
            <g id="Page-1">
                <g id="Group">
                    <polygon id="Fill-1" fill="#2AB7EA" stroke="#2AB7EA" points="10 11.8066667 11.0802793 11.8066667 11.0802793 0 10 0"></polygon>
                    <path d="M1.40270667,2.35372248 L1.40270667,0.502602201 C1.40270667,0.405141509 1.47168858,0.326666667 1.55649204,0.326666667 L10.6684339,0.326666667 C10.7538702,0.326666667 10.8222192,0.405141509 10.8222192,0.502602201 L10.8222192,11.9573978 C10.8222192,12.0548585 10.7538702,12.1333333 10.6684339,12.1333333 C10.0841852,12.1333333 9.64599874,12.1333333 9.35387442,12.1333333" id="Stroke-1"></path>
                    <path d="M0,4.07085478 L0,2.25103208 C0,2.1552192 0.067815615,2.07807116 0.15118527,2.07807116 L9.10906806,2.07807116 C9.19305988,2.07807116 9.26025333,2.1552192 9.26025333,2.25103208 C9.26025333,3.52125305 9.26025333,5.44235295 9.26025333,6.01433177 M9.26025333,9.88220635 C9.26025333,10.4666399 9.26025333,12.3432901 9.26025333,13.5121571 C9.26025333,13.60797 9.19305988,13.6851181 9.10906806,13.6851181 L0.15118527,13.6851181 C0.067815615,13.6851181 0,13.60797 0,13.5121571 L0,3.51735397" id="Stroke-1"></path>
                    <g id="Group-2" transform="translate(6.000000, 6.000000)" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M0,1.88338 L3.12795,1.88338" id="Stroke-7"></path>
                        <polyline id="Stroke-9" points="1.88055 0.33918 3.12795 1.88338 1.88055 3.39818"></polyline>
                    </g>
                    <path d="M1.5,4.5 L6.5,4.5" id="Line-Copy" strokeLinecap="round" strokeLinejoin="round"></path>
                    <path d="M1.5,6.5 L4.5,6.5" id="Line-Copy-2" strokeLinecap="round" strokeLinejoin="round"></path>
                    <path d="M1.5,8.5 L3.5,8.5" id="Line-Copy-3" strokeLinecap="round" strokeLinejoin="round"></path>
                </g>
            </g>
        </g>
    </g>
	</svg>
    )
  }
}
